import { render } from "./menu-sidebar.vue?vue&type=template&id=68a590e8&scoped=true&ts=true"
import script from "./menu-sidebar.vue?vue&type=script&lang=ts"
export * from "./menu-sidebar.vue?vue&type=script&lang=ts"

import "./menu-sidebar.vue?vue&type=style&index=0&id=68a590e8&scoped=true&lang=css"

import exportComponent from "/Users/nhonnguyen/Documents/exoty/frontend/exoty-backoffice-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a590e8"]])

export default __exports__